import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';

import { ReachProSupportThreadPopup } from './ReachProSupportThreadPopup';

type ReachProSupportThreadPopupContextValue = {
  openSupportThreadPopup: (workItemId: number) => void;
  closeSupportThreadPopup: () => void;
};

const ReachProSupportThreadPopupContext =
  createContext<ReachProSupportThreadPopupContextValue>({
    openSupportThreadPopup: () => undefined,
    closeSupportThreadPopup: () => undefined,
  });

export const useReachProSupportThreadPopupContext = () =>
  useContext(ReachProSupportThreadPopupContext);

export function ReachProSupportThreadPopupProvider({
  children,
}: PropsWithChildren) {
  const [activeWorkItemId, setActiveWorkItemId] = useState<number | null>(null);
  const { pathname } = useLocation();

  // Close the popup whenever the main route changes (close on navigation away).
  useEffect(() => {
    setActiveWorkItemId(null);
  }, [pathname]);

  const value = useMemo(
    () => ({
      openSupportThreadPopup: (workItemId: number) =>
        setActiveWorkItemId(workItemId),
      closeSupportThreadPopup: () => setActiveWorkItemId(null),
    }),
    []
  );

  return (
    <ReachProSupportThreadPopupContext.Provider value={value}>
      {children}
      {activeWorkItemId != null && (
        <ReachProSupportThreadPopup
          workItemId={activeWorkItemId}
          onClose={() => setActiveWorkItemId(null)}
        />
      )}
    </ReachProSupportThreadPopupContext.Provider>
  );
}
